// export const instrumentationKey = process.env.NODE_ENV === "production" ? "28ddffff-2c71-45cf-9b51-96cfea8dd8e3" : "2b353218-9dfe-43eb-abe3-4f01c663f6bf"
export const instrumentationKey = "2b353218-9dfe-43eb-abe3-4f01c663f6bf"
